import axios from 'axios';
import { normalizeEntitlementVideoInPayload } from './helpers/normalizeVideoAssetsForShaka';
axios.interceptors.response.use((response) => {
    try {
        if (response === null || response === void 0 ? void 0 : response.data) {
            normalizeEntitlementVideoInPayload(response.data);
        }
    }
    catch (_) {
        /* no-op */
    }
    return response;
}, (err) => Promise.reject(err));
